import {
  Center,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerProps,
  FormControl,
  Heading,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { usePostAfeDocumentUploadLinkMutation } from 'api';
import { AfeResponse } from 'api/bindings/AfeResponse';
import { useAuth } from 'core';
import { FormButtonGroup } from 'features/components';
import { useRef } from 'react';
import { FormProvider, useFieldArray, useForm } from 'react-hook-form';
import { toast } from 'toast';

interface Form {
  attachments: { name: string; size: number }[];
}
export interface AfeUploadDocumentsDrawerProps
  extends Omit<DrawerProps, 'children'> {
  afe: AfeResponse | undefined;
  onUpload: () => void;
}

export const AfeUploadDocumentsDrawer = (
  props: AfeUploadDocumentsDrawerProps
) => {
  const { afe, ...rest } = props;

  const auth = useAuth();
  const form = useForm<Form>();
  const { control, handleSubmit } = form;

  const attachmentsField = useFieldArray({
    name: 'attachments',
    control,
    keyName: '_id',
    rules: {
      minLength: 1,
    },
  });

  const fileRef = useRef<HTMLInputElement>(null);

  const [requestUploadLink] = usePostAfeDocumentUploadLinkMutation();
  // const [requestDocumentsUpload] = usePostRequestAfeDocumentUploadsMutation();

  const onSubmit = async (form: Form) => {
    toast({
      status: 'loading',
      title: 'Attachment upload in progress. Please do not refresh the page.',
    });

    const fileList = fileRef.current?.files;
    if (!fileList) return;

    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      const meta = form.attachments[i];

      const linkResult = await requestUploadLink({
        clientId: auth?.user.clientId ?? "0",
        afeId: afe?.id ?? "0",
        fileName: meta.name,
      });

      if ('error' in linkResult) {
        return linkResult;
      }

      // const fd = new FormData();
      // fd.append('File', file);

      const uploadResult = await fetch(linkResult.data.url, {
        method: 'PUT',
        body: file,
      });

      if (!('error' in uploadResult)) {
        props.onUpload();
        props.onClose();
      }

      return uploadResult;
    }

    // // const uploadRequestResponse = await requestDocumentsUpload({
    // //   afeId: afe!.id,
    // //   files: form.attachments,
    // // });

    // // if ('error' in uploadRequestResponse) {
    // //   throw uploadRequestResponse;
    // // }

    // // const urls = uploadRequestResponse.data.urls;
    // // const fileList = fileRef?.current?.files;

    // // const uploads = urls.map((url, i) => {
    // //   const fd = new FormData();
    // //   const file = fileList![i];
    // //   fd.append('file', file);
    // //   return postDocument({ url, form: fd });
    // // });

    // // const result = await Promise.all(uploads);
    // // props.onClose();

    // const fileList = fileRef.current?.files;
    // if (!fileList) return;

    // const fd = new FormData();
    // for (let i = 0; i < fileList.length ?? 0; i++) {
    //   const file = fileList[i];
    //   fd.append('files', file);
    // }

    // const result = await postDocument({ afeId: afe?.id ?? 0, form: fd });
    // if ('error' in result) {
    //   toast({
    //     status: 'error',
    //     title: 'Failed to upload document(s)!',
    //   });
    //   return result;
    // }

    toast({
      status: 'success',
      title: 'Attachments uploaded successfully',
    });

    return { data: { success: true } };
  };

  return (
    <Drawer {...rest} size="xl">
      <FormProvider {...form}>
        <DrawerCloseButton />
        <DrawerContent>
          <DrawerHeader>
            <Heading size="xs">Upload Documents to AFE {afe?.name}</Heading>
          </DrawerHeader>
          <DrawerBody>
            <Stack gap={[4, 6]}>
              <FormControl>
                <input
                  type="file"
                  id="file"
                  name="attachments"
                  multiple
                  ref={fileRef}
                  onChange={(e) => {
                    const file = e?.target?.files?.[0];
                    if (!file) return;
                    attachmentsField.append({
                      name: file.name,
                      size: file.size,
                    });
                  }}
                />
              </FormControl>
              <TableContainer>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>File</Th>
                      <Th>Size</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {!attachmentsField.fields?.length && (
                      <Tr>
                        <Td colSpan={2}>
                          <Center>No Files to Upload</Center>
                        </Td>
                      </Tr>
                    )}
                    {attachmentsField.fields?.map((attachment) => (
                      <Tr key={(attachment as any)._id}>
                        <Td>{attachment.name}</Td>
                        <Td>{attachment.size}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Stack>
          </DrawerBody>
          <DrawerFooter>
            <FormButtonGroup
              onCancel={props.onClose}
              onConfirm={handleSubmit(onSubmit)}
            />
          </DrawerFooter>
        </DrawerContent>
      </FormProvider>
    </Drawer>
  );
};
